package org.teddapp.project.sync

import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import org.teddapp.project.server.ServerSession

@OptIn(DelicateCoroutinesApi::class)
internal actual fun restoreAtStartup(session: ServerSession) {
    GlobalScope.launch { runCatching { session.restore() } }
}
